module.exports = __webpack_public_path__ + "img/SLR.346fda25.svg";